import { pathOr } from 'ramda';
import {
  DOWNCASE_MONTHLY_INTERVAL_PERIOD,
  DOWNCASE_WEEKLY_INTERVAL_PERIOD,
  JOIN_SEMIMONTHLY_INTERVAL_PERIOD_NAME,
  DOWNCASE_DAILY_INTERVAL_PERIOD,
} from 'src/features/Advisors/constants';
import {
  LLC_LABEL,
  C_CORP_LABEL,
  PARTNERSHIP_LABEL,
  OTHERS,
} from 'src/features/ApplicationWorkflows/SBAPPP/constants';
import {
  DOCUSIGN_CHECKBOX_FIELD_TYPE,
  DOCUSIGN_INTIALS_FIELD_TYPE,
  DOCUSIGN_TEXTBOX_FIELD_TYPE,
  DOCUSIGN_SIGNATURE_FIELD_TYPE,
  DATA_PATH_SEPERATOR,
} from '../TemplateMatcher';

export const BC_CONTRACT_EMAIL_SUBJECT = (businessName: string) =>
  `Breakout Capital - E-sign link (${businessName})`;

/* Edited using online html maker
  https://html-online.com/editor/
  */
export const BC_CONTRACT_EMAIL_BODY_CONTENT = (neccessaryData: any) => `
<div>Dear ${pathOr('', ['ownerName'], neccessaryData)},<br>
<br>
You received this e-mail because you recently submitted an application to Breakout Capital. If you did not submit an application you can safely ignore this message.<br>
<br>
Please click "Review Document" above to sign the documents <br>
<br>
Attached is a pdf copy of the un-signed contract for you records but please sign digitally with the link provided above.<br>
<br>
Breakout Capital provides bank level security. The process is completely safe and all your information will be secure.<br>
<br>
Specialists are available to help you Monday to Friday between 9 am and 6 pm EST.
Call (888) 318-3534<br>

<br>
Please note that this offer is contingent upon the following stipulations. Any documentation listed below that has not already been provided should be sent to credit@breakoutfinance.com (You do not need to re-submit any document that you have already provided to us.)<br>
<br>

`;

const BUSINESS_TYPE_LLC = {
  field_type: DOCUSIGN_CHECKBOX_FIELD_TYPE,
  api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}legal_entity`,
  label: LLC_LABEL,
  other_args: {
    tab_label: '000_BC_BORROWER_TYPE_LLC',
    selected: 'true',
    x_position: 280,
    y_position: 355,
  },
};
const BUSINESS_TYPE_PARTNERSHIP = {
  field_type: DOCUSIGN_CHECKBOX_FIELD_TYPE,
  api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}legal_entity`,
  label: PARTNERSHIP_LABEL,
  other_args: {
    tab_label: '000_BC_BORROWER_TYPE_PARTNERSHIP',
    selected: 'true',
    x_position: 253,
    y_position: 368,
  },
};
const BUSINESS_TYPE_OTHER = {
  field_type: DOCUSIGN_CHECKBOX_FIELD_TYPE,
  api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}legal_entity`,
  label: OTHERS,
  other_args: {
    tab_label: '000_BC_BORROWER_TYPE_OTHER',
    selected: 'true',
    x_position: 496,
    y_position: 368,
  },
};
const BUSINESS_TYPE_CORP = {
  field_type: DOCUSIGN_CHECKBOX_FIELD_TYPE,
  api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}legal_entity`,
  label: C_CORP_LABEL,
  other_args: {
    tab_label: '000_BC_BORROWER_TYPE_CORP',
    selected: 'true',
    x_position: 208,
    y_position: 356,
  },
};
const BC_CHECK_BOX_MONTHLY = {
  field_type: DOCUSIGN_CHECKBOX_FIELD_TYPE,
  api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/payment_cycle`,
  label: DOWNCASE_MONTHLY_INTERVAL_PERIOD,
  other_args: {
    tab_label: '000_BC_MONTHLY_INTERVAL',
    selected: 'true',
    x_position: 207,
    y_position: 194,
  },
};
const BC_CHECK_BOX_WEEKLY = {
  field_type: DOCUSIGN_CHECKBOX_FIELD_TYPE,
  api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/payment_cycle`,
  label: DOWNCASE_WEEKLY_INTERVAL_PERIOD,
  other_args: {
    tab_label: '000_BC_WEEKLY_INTERVAL',
    selected: 'true',
    x_position: 206,
    y_position: 135,
  },
};
const BC_CHECK_BOX_DAILY = {
  field_type: DOCUSIGN_CHECKBOX_FIELD_TYPE,
  api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/payment_cycle`,
  label: DOWNCASE_DAILY_INTERVAL_PERIOD,
  other_args: {
    tab_label: '000_BC_DAILY_INTERVAL',
    selected: 'true',
    x_position: 208,
    y_position: 113,
  },
};
const BC_CHECK_BOX_SEMIMONTH = {
  field_type: DOCUSIGN_CHECKBOX_FIELD_TYPE,
  api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/payment_cycle`,
  label: JOIN_SEMIMONTHLY_INTERVAL_PERIOD_NAME,
  other_args: {
    tab_label: '000_BC_SEMIMONTH_INTERVAL',
    selected: 'true',
    x_position: 204,
    y_position: 160,
  },
};
export const BC_CONTRACT_PRE_FIELDS_CHECK_BOX_FIELDS = [
  BUSINESS_TYPE_LLC,
  BUSINESS_TYPE_CORP,
  BC_CHECK_BOX_MONTHLY,
  BC_CHECK_BOX_SEMIMONTH,
  BUSINESS_TYPE_PARTNERSHIP,
  BC_CHECK_BOX_WEEKLY,
  BC_CHECK_BOX_DAILY,
  BUSINESS_TYPE_OTHER,
];

export const BC_CONTRACT_PRE_TEXT_FIELDS = [
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `calculations${DATA_PATH_SEPERATOR}total_repayment_amount_with_format`,
    other_args: {
      tab_label: '000_BC_REPAYMENT_AMOUNT',
      x_position: 218,
      y_position: 475,
    },
  },
  ,
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/originating_fee_with_format`,
    other_args: {
      tab_label: '000_BC_ORIGINATION_FEE',
      x_position: 326,
      y_position: 524,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/loan_amount_with_format`,
    other_args: {
      tab_label: '000_BC_ORIGINATION_AMOUNT',
      x_position: 222,
      y_position: 457,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `calculations${DATA_PATH_SEPERATOR}total_repayment_amount_with_format`,
    other_args: {
      tab_label: '000_BC_TOTAL_CAPITAL_COST',
      x_position: 220,
      y_position: 630,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/interest_amount_with_format`,
    other_args: {
      tab_label: '000_BC_INTEREST_AMOUNT',
      x_position: 218,
      y_position: 622,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/payoff_amount_with_format`,
    other_args: {
      tab_label: '000_BC_PAYOFF_AMOUNT',
      x_position: 210,
      y_position: 584,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/periodic_payment_with_format`,
    other_args: {
      tab_label: '000_BC_MONTHLY_PAYMENT_AMOUNT',
      x_position: 218,
      y_position: 475,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/interest_fee`,
    other_args: {
      tab_label: '000_BC_INTEREST FEE',
      x_position: 331,
      y_position: 474,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/payments`,
    other_args: {
      tab_label: '000_BC_PAYMENT_TERMS',
      x_position: 208,
      y_position: 283,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/first_day_for_week`,
    other_args: {
      tab_label: '000_BC_FIRST_PAYMENT_DAY_FOR_WEEKLY',
      x_position: 291,
      y_position: 134,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/first_date_for_semimonthly`,
    other_args: {
      tab_label: '000_BC_FIRST_PAYMENT_DATE_FOR_SEMIMONTHLY',
      x_position: 314,
      y_position: 159,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/second_date_for_semimonthly`,
    other_args: {
      tab_label: '000_BC_SECOND_PAYMENT_DATE_FOR_SEMIMONTHLY',
      x_position: 389,
      y_position: 161,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/first_date_for_month`,
    other_args: {
      tab_label: '000_BC_FIRST_PAYMENT_DATE_FOR_MONTHLY',
      x_position: 294,
      y_position: 194,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}name`,
    other_args: {
      tab_label: '000_BC_PRINT_PRICIPLE_OWNER_NAME',
      x_position: 314,
      y_position: 139,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}title`,
    other_args: {
      tab_label: '000_BC_PRINT_TITLE_PRINCIPLE_OWNER',
      x_position: 373,
      y_position: 138,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/bank_name`,
    other_args: {
      tab_label: '000_BC_BANK_ACCOUNT_NAME',
      x_position: 373,
      y_position: 138,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lensmart_sh/bankacc_no`,
    other_args: {
      tab_label: '000_BC_BANK_ACCOUNT_NO',
      x_position: 373,
      y_position: 138,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/bank_routing_no`,
    other_args: {
      tab_label: '000_BC_BANK_ROUTING_NO',
      x_position: 373,
      y_position: 138,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/factor_rate`,
    other_args: {
      tab_label: '000_BC_FACTOR_RATE',
      x_position: 373,
      y_position: 138,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/interest_amount_with_format`,
    other_args: {
      tab_label: '000_BC_INTEREST_AMOUNT',
      x_position: 373,
      y_position: 138,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}business_name`,
    other_args: {
      tab_label: '000_BC_BUSINESS_NAME',
      x_position: 208,
      y_position: 335,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `calculations${DATA_PATH_SEPERATOR}address_and_suite`,
    other_args: {
      tab_label: '000_BC_BUSINESS_ADDRESS',
      x_position: 312,
      y_position: 457,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}name`,
    other_args: {
      tab_label: '000_BC_BUSINESS_OWNER_0_NAME',
      x_position: 417,
      y_position: 401,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}title`,
    other_args: {
      tab_label: '000_BC_BUSINESS_OWNER_0_TITLE',
      x_position: 314,
      y_position: 403,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}share`,
    other_args: {
      tab_label: '000_BC_BUSINESS_OWNER_0_SHARE',
      x_position: 178,
      y_position: 554,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `firstOwnerAddressDesurd${DATA_PATH_SEPERATOR}street`,
    other_args: {
      tab_label: '000_BC_BUSINESS_OWNER_0_STREET',
      x_position: 125,
      y_position: 605,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `firstOwnerAddressDesurd${DATA_PATH_SEPERATOR}city`,
    other_args: {
      tab_label: '000_BC_BUSINESS_OWNER_0_CITY',
      x_position: 124,
      y_position: 646,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `firstOwnerAddressDesurd${DATA_PATH_SEPERATOR}state`,
    other_args: {
      tab_label: '000_BC_BUSINESS_OWNER_0_STATE',
      x_position: 329,
      y_position: 644,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `firstOwnerAddressDesurd${DATA_PATH_SEPERATOR}zip`,
    other_args: {
      tab_label: '000_BC_BUSINESS_OWNER_0_ZIP',
      x_position: 397,
      y_position: 645,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}tin_ein_ssn`,
    other_args: {
      tab_label: '000_BC_BUSINESS_EIN',
      x_position: 125,
      y_position: 645,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}dob`,
    other_args: {
      tab_label: '000_BC_BUSINESS_OWNER_0_DOB',
      x_position: 370,
      y_position: 666,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}1${DATA_PATH_SEPERATOR}name`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_1_NAME',
      x_position: 126,
      y_position: 183,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}2${DATA_PATH_SEPERATOR}name`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_2_NAME',
      x_position: 125,
      y_position: 324,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}3${DATA_PATH_SEPERATOR}name`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_3_NAME',
      x_position: 126,
      y_position: 460,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}1${DATA_PATH_SEPERATOR}title`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_1_TITLE',
      x_position: 373,
      y_position: 138,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}1${DATA_PATH_SEPERATOR}share`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_1_SHARE',
      x_position: 180,
      y_position: 138,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}2${DATA_PATH_SEPERATOR}share`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_2_SHARE',
      x_position: 180,
      y_position: 294,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}2${DATA_PATH_SEPERATOR}share`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_3_SHARE',
      x_position: 179,
      y_position: 429,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `secondOwnerAddressDesurd${DATA_PATH_SEPERATOR}street`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_1_STREET',
      x_position: 125,
      y_position: 203,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `thirdOwnerAddressDesurd${DATA_PATH_SEPERATOR}street`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_2_STREET',
      x_position: 124,
      y_position: 343,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `fourthOwnerAddressDesurd${DATA_PATH_SEPERATOR}street`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_3_STREET',
      x_position: 126,
      y_position: 481,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `secondOwnerAddressDesurd${DATA_PATH_SEPERATOR}city`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_1_CITY',
      x_position: 125,
      y_position: 245,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `thirdOwnerAddressDesurd${DATA_PATH_SEPERATOR}city`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_2_CITY',
      x_position: 124,
      y_position: 383,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `fourthOwnerAddressDesurd${DATA_PATH_SEPERATOR}city`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_3_CITY',
      x_position: 125,
      y_position: 524,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `secondOwnerAddressDesurd${DATA_PATH_SEPERATOR}state`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_1_STATE',
      x_position: 331,
      y_position: 244,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `thirdOwnerAddressDesurd${DATA_PATH_SEPERATOR}state`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_2_STATE',
      x_position: 326,
      y_position: 383,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `fourthOwnerAddressDesurd${DATA_PATH_SEPERATOR}state`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_3_STATE',
      x_position: 330,
      y_position: 523,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `secondOwnerAddressDesurd${DATA_PATH_SEPERATOR}zip`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_1_ZIP',
      x_position: 406,
      y_position: 244,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `thirdOwnerAddressDesurd${DATA_PATH_SEPERATOR}zip`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_2_ZIP',
      x_position: 415,
      y_position: 383,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `fourthOwnerAddressDesurd${DATA_PATH_SEPERATOR}zip`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_3_ZIP',
      x_position: 408,
      y_position: 521,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}3${DATA_PATH_SEPERATOR}tin_ein_ssn`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_3_SSN',
      x_position: 127,
      y_position: 543,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}2${DATA_PATH_SEPERATOR}tin_ein_ssn`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_2_SSN',
      x_position: 126,
      y_position: 403,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}1${DATA_PATH_SEPERATOR}tin_ein_ssn`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_1_SSN',
      x_position: 123,
      y_position: 263,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}dob1`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_1_DOB',
      x_position: 374,
      y_position: 265,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}dob2`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_2_DOB',
      x_position: 377,
      y_position: 403,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}dob3`,
    other_args: {
      tab_label: '001_BC_BUSINESS_OWNER_3_DOB',
      x_position: 374,
      y_position: 543,
    },
  },
  {
    field_type: DOCUSIGN_INTIALS_FIELD_TYPE,
    api_resource_path: 'initials',
    other_args: {
      tab_label: '000_BC_INTITALS',
      x_position: 557,
      y_position: 717,
    },
  },
  {
    field_type: DOCUSIGN_SIGNATURE_FIELD_TYPE,
    api_resource_path: 'signature',
    other_args: {
      tab_label: '000_BC_SIGNATURE',
      x_position: 67,
      y_position: 139,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `bankAccount${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}bank_acc_no`,
    other_args: {
      tab_label: '000_BC_BANK_ACCOUNT_NO',
      x_position: 324,
      y_position: 333,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `bankAccount${DATA_PATH_SEPERATOR}1${DATA_PATH_SEPERATOR}bank_acc_no`,
    other_args: {
      tab_label: '001_BC_BANK_ACCOUNT_NO',
      x_position: 320,
      y_position: 431,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `bankAccount${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}bank_routing_no`,
    other_args: {
      tab_label: '000_BC_BANK_ACCOUNT_ROUTING_NO',
      x_position: 333,
      y_position: 308,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `bankAccount${DATA_PATH_SEPERATOR}1${DATA_PATH_SEPERATOR}bank_routing_no`,
    other_args: {
      tab_label: '001_BC_BANK_ACCOUNT_ROUTING_NO',
      x_position: 325,
      y_position: 403,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `bankAccount${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}bank_name`,
    other_args: {
      tab_label: '000_BC_BANK_ACCOUNT_NAME',
      x_position: 337,
      y_position: 283,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `bankAccount${DATA_PATH_SEPERATOR}1${DATA_PATH_SEPERATOR}bank_name`,
    other_args: {
      tab_label: '001_BC_BANK_ACCOUNT_NAME',
      x_position: 326,
      y_position: 382,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/disbursement_amount`,
    other_args: {
      tab_label: '000_BC_DISBURSEMENT_AMOUNT',
      x_position: 196,
      y_position: 140,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/loan_fee_with_format`,
    other_args: {
      tab_label: '000_BC_LOAN_FEE',
      x_position: 285,
      y_position: 198,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/other_fees_with_format`,
    other_args: {
      tab_label: '000_BC_OTHER_FEES',
      x_position: 285,
      y_position: 229,
    },
  },

  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/cents_with_prefix`,
    other_args: {
      tab_label: '000_BC_CENTS_ON_THE_DOLLAR',
      x_position: 283,
      y_position: 510,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/disbursement_amount`,
    other_args: {
      tab_label: '000_BC_DISBURSEMENT_AMOUNT',
      x_position: 196,
      y_position: 140,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/loan_fee_with_format`,
    other_args: {
      tab_label: '000_BC_LOAN_FEE',
      x_position: 285,
      y_position: 198,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/annunal_percentage_rate_with_prefix`,
    other_args: {
      tab_label: '000_BC_ANNUAL_PERCENTAGE_RATE',
      x_position: 280,
      y_position: 329,
    },
  },

  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/disbursement_amount_with_prefix`,
    other_args: {
      tab_label: '000_BC_DISBURSEMENT_AMOUNT_WITH_PREFIX',
      x_position: 196,
      y_position: 140,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/loan_amount_with_prefix`,
    other_args: {
      tab_label: '000_BC_ORIGINATION_AMOUNT_WITH_PREFIX',
      x_position: 69,
      y_position: 143,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `calculations${DATA_PATH_SEPERATOR}total_cost_of_capital_with_prefix`,
    other_args: {
      tab_label: '000_BC_TOTAL_CAPITAL_COST_WITH_PREFIX',
      x_position: 71,
      y_position: 217,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `calculations${DATA_PATH_SEPERATOR}total_cost_of_capital_with_format`,
    other_args: {
      tab_label: '000_BC_TOTAL_CAPITAL_COST',
      x_position: 71,
      y_position: 217,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `calculations${DATA_PATH_SEPERATOR}total_repayment_amount_with_prefix`,
    other_args: {
      tab_label: '000_BC_REPAYMENT_AMOUNT_WITH_PREFIX',
      x_position: 303,
      y_position: 139,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `calculations${DATA_PATH_SEPERATOR}bc_monthly_payment_with_prefix`,
    other_args: {
      tab_label: '000_BC_MONTHLY_PAYMENT_AMOUNT_WITH_PREFIX',
      x_position: 71,
      y_position: 390,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/interest_amount_with_prefix`,
    other_args: {
      tab_label: '000_BC_INTEREST_AMOUNT_WITH_PREFIX',
      x_position: 287,
      y_position: 185,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/loan_fee_with_prefix`,
    other_args: {
      tab_label: '000_BC_LOAN_FEE_WITH_PREFIX',
      x_position: 285,
      y_position: 198,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/originating_fee_with_prefix`,
    other_args: {
      tab_label: '000_BC_ORIGINATION_FEE_WITH_PREFIX',
      x_position: 284,
      y_position: 213,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/other_fees_with_prefix`,
    other_args: {
      tab_label: '000_BC_OTHER_FEES_WITH_PREFIX',
      x_position: 285,
      y_position: 229,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/payment_cycle`,
    other_args: {
      tab_label: '00_BC_PAYMENT_INTERVAL',
      x_position: 439,
      y_position: 146,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}lendsmart_sh/terms`,
    other_args: {
      tab_label: '000_BC_PAYMENT_TERMS_SMART_BOX',
      x_position: 447,
      y_position: 124,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}owners${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}tin_ein_ssn`,
    other_args: {
      tab_label: '000_BC_BUSINESS_OWNER_0_SSN',
      x_position: 127,
      y_position: 664,
    },
  },
  {
    field_type: DOCUSIGN_TEXTBOX_FIELD_TYPE,
    api_resource_path: `business${DATA_PATH_SEPERATOR}0${DATA_PATH_SEPERATOR}metadata${DATA_PATH_SEPERATOR}dba`,
    other_args: {
      tab_label: '000_BC_BUSINESS_DBA',
      x_position: 385,
      y_position: 335,
    },
  },
];
